import React from "react";
import { FileText } from "lucide-react";

export default function EulaModal({
  setShowEulaModal,
}: {
  setShowEulaModal: (v: boolean) => void;
}) {
  const acceptEula = () => {
    localStorage.setItem("mypaws_eula_accepted", "true");
    setShowEulaModal(false);
  };

  return (
    <div className="fixed inset-0 bg-black/80 z-[999] flex items-center justify-center p-4 backdrop-blur-sm">
      <div className="bg-[var(--bg-card)] rounded-3xl p-6 w-full max-w-sm flex flex-col gap-4 animate-scale-up border border-[var(--border-color)]">
        <div className="w-14 h-14 bg-[var(--accent-soft)] text-[#a073e7] rounded-full flex items-center justify-center mx-auto mb-2">
          <FileText size={28} />
        </div>
        <h3 className="font-black text-xl text-center text-[var(--text-main)]">
          Угода користувача
        </h3>
        <div className="bg-[var(--bg-soft)] p-4 rounded-xl text-xs text-[var(--text-main)] max-h-[40vh] overflow-y-auto leading-relaxed border border-[var(--border-color)]">
          <p className="font-bold mb-2">Правила спільноти MyPaws (EULA):</p>
          <ul className="list-disc pl-4 space-y-2">
            <li>
              Категорично заборонено публікувати контент, що містить насильство,
              спам, образи або незаконні матеріали.
            </li>
            <li>Ви можете поскаржитися (Report) на будь-який контент.</li>
            <li>Ви можете заблокувати (Block) будь-якого користувача.</li>
          </ul>
        </div>
        <button
          onClick={acceptEula}
          className="w-full py-4 mt-2 bg-[#a073e7] text-white font-bold rounded-xl active:scale-95 shadow-md"
        >
          Погоджуюсь
        </button>
      </div>
    </div>
  );
}
